import { render, staticRenderFns } from "./ConfiguracaoGeral.vue?vue&type=template&id=050cfd8e&scoped=true&"
import script from "./ConfiguracaoGeral.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050cfd8e",
  null
  
)

export default component.exports